export var DEFAULT_LABELKEY = 'label';
export var SIZES = ['large', 'lg', 'small', 'sm'];